import { KibCheckbox } from '@chewy/kib-choices-react'
import { KibGrid, KibGridItem } from '@chewy/kib-layout-react'

import type { HeaderFilter } from '../dashboard/communications/filters/ConversationFilters'

import '@chewy/kib-layout-styles/dist/styles/kib-grid.css'
import '@chewy/kib-choices-styles/dist/styles/kib-checkbox.css'
import styles from './ConversationCheckboxFilters.module.scss'

const ConversationCheckboxFilters = ({
  filters,
  label,
}: {
  filters: HeaderFilter[]
  label?: string
}) => (
  <KibGrid
    className={styles.conversationCheckboxFilters}
    role="group"
    valign="center"
  >
    {label && <KibGridItem className={styles.groupLabel}>{label} </KibGridItem>}
    {filters.map((filter) => (
      <KibGridItem key={filter.text}>
        <KibCheckbox
          label={filter.text}
          selectedValue={filter.active}
          onChange={filter.onSelected}
        />
      </KibGridItem>
    ))}
  </KibGrid>
)

export default ConversationCheckboxFilters
